const ConversationType = {
	Topic: {
		label: 'Topic',
		key: 'topic',
	},
	Title: {
		label: 'Title',
		key: 'title',
		doOfferCandidate: true,
	},
};

export default ConversationType;
